import type { ReactElement } from 'react';
import { Text } from '@fastnorth/kraken/components/typography';

type FormatOrdinalProps = {
  value?: string;
};

const FormatOrdinal = ({ value }: FormatOrdinalProps): ReactElement | null => {
  if (!value) return null;

  // Check if the value matches an ordinal format (e.g., 1st, 2nd, 3rd, 4th, 345342nd)
  const ordinalMatch = value.match(/^(\d+)(st|nd|rd|th)$/);

  if (ordinalMatch) {
    const number = ordinalMatch[1];
    const suffix = ordinalMatch[2];
    return (
      <Text>
        {number}
        <sup>{suffix}</sup>
      </Text>
    );
  }

  return <Text>{value}</Text>;
};

export default FormatOrdinal;
